import React, { useEffect, useState } from "react";
import { getAllItemsSearch } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
// import "./party.css";
import { getAllParty } from "../../api/endpoints/party";
import {
  createVehical,
  getAllVehical,
  updateSingleVehical,
  deleteSingleVehical,
} from "../../api/endpoints/vehical";
const { Option } = Select;

const Vehical = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    items: [],
    parties: [],
    regNumberList: [],
    itemCode: "",
    itemName: "",
    partyId: "",
    partyName: "",
    regNumber: "",
    numaricNumber: "",
    closed: "",
  });

  const clearState = () => {
    setState({
      id: "",
      parties: state.parties,
      items: state.items,
      regNumberList: state.regNumberList,
      itemCode: "",
      itemName: "",
      partyId: "",
      partyName: "",
      regNumber: "",
      numaricNumber: "",
      closed: "",
    });
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
    setState({
      ...state,
      closed: 0,
    });
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.partyId ||
      !state.partyName ||
      !state.regNumber ||
      !state.numaricNumber ||
      !state.itemCode
    ) {
      return message.error(
        `Please type ${
          !state.regNumber
            ? "Registration Number"
            : !state.numaricNumber
            ? "Numaric Number"
            : !state.partyId
            ? "Account Number"
            : !state.partyName
            ? "Party Name"
            : !state.itemCode
            ? "Item"
            : ""
        }`
      );
    }

    const payload = {
      partyId: state.partyId,
      regNumber: state.regNumber,
      numericNumber: state.numaricNumber,
      itemCode: state.itemCode,
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await createVehical(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.partyId ||
        !state.partyName ||
        !state.regNumber ||
        !state.numaricNumber ||
        !state.itemCode
      ) {
        return message.error(
          `Please type ${
            !state.regNumber
              ? "Registration Number"
              : !state.numaricNumber
              ? "Numaric Number"
              : !state.partyId
              ? "Account Number"
              : !state.partyName
              ? "Party Name"
              : !state.itemCode
              ? "Item"
              : ""
          }`
        );
      }
      const data = {
        id: state.id,
        partyId: state.partyId,
        regNumber: state.regNumber,
        numericNumber: state.numaricNumber,
        itemCode: state.itemCode,
      };
      console.log(data, "edite data");
      const results = await updateSingleVehical(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.regNumber) return message.error("Please Select Vehical");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Vehical?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      id: state.id,
    };
    const results = await deleteSingleVehical(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Vehicle?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _parties = await getAllParty(access_token);
    const _regNumberList = await getAllVehical(access_token);
    const _items = await getAllItemsSearch(access_token);
    setState({
      ...state,
      parties: _parties,
      regNumberList: _regNumberList,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(state, "state");
  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Create Vehicle</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Registration Number :
                        </label>
                        {type === "EDIT" || type === "DELETE" ? (
                          <>
                            <Select
                              className="bg-black text-slate-400 inpTxt  h-8 w-full"
                              showSearch
                              placeholder=""
                              optionFilterProp="children"
                              value={state.regNumber || ""}
                              onChange={(e) => {
                                const _accountInfo = state.regNumberList.find(
                                  (el) => el.id === e
                                );
                                console.log("e", _accountInfo);

                                setState({
                                  ...state,
                                  id: e,
                                  regNumber: _accountInfo.regNumber,
                                  numaricNumber: _accountInfo.numericNumber,
                                  partyId: _accountInfo.partyId,
                                  itemCode: _accountInfo.itemCode,
                                  itemName: _accountInfo.item.itemName,
                                  partyName: _accountInfo.party.partyName,
                                });
                              }}
                            >
                              {state.regNumberList.map((el) => (
                                // console.log(el, "el")
                                <Option value={el.id}>
                                  {`${el.regNumber}`}
                                </Option>
                              ))}
                            </Select>
                          </>
                        ) : (
                          <input
                            type="text"
                            name="regNumber"
                            value={state.regNumber}
                            onChange={onChangeText}
                            className="bg-black text-slate-400 pl-2  inpTxt h-8 w-full"
                          />
                        )}
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Numaric Number :
                        </label>
                        <input
                          type="Number"
                          name="numaricNumber"
                          value={state.numaricNumber}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>

                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Item Code :
                        </label>
                        {/* <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.partyType || "Item Id"}
                          onChange={(value) =>
                            onChangeText({
                              target: { name: "partyType", value },
                            })
                          }
                        >
                          <Option value={"Customer"} name="partyType">
                            Customer
                          </Option>
                          <Option value={"Card"} name="partyType">
                            Card
                          </Option>
                          <Option value={"Supplier"} name="partyType">
                            Supplier
                          </Option>
                          <Option value={"Miscellaneous"} name="partyType">
                            Miscellaneous
                          </Option>
                        </Select> */}
                        <Select
                          showSearch
                          placeholder="Item"
                          className="text-black inpTxt  h-9 w-full"
                          optionFilterProp="children"
                          value={state.itemCode || "Item"}
                          onChange={(e) => {
                            console.log("e", e);

                            const _item = state.items.find(
                              (el) => el.itemCode === e
                            );
                            if (_item) {
                              setState({
                                ...state,
                                itemCode: e,
                                itemName: _item.itemName,
                              });
                            }
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemCode}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Item Name :
                        </label>
                        {/* <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.billType || "Vehicle Wise"}
                          onChange={(value) =>
                            onChangeText({
                              target: { name: "billType", value },
                            })
                          }
                        >
                          <Option value={"Customer Wise"} name="billType">
                            Customer Wise
                          </Option>
                          <Option value={"Vehicle Wise"} name="billType">
                            Vehicle Wise
                          </Option>
                        </Select> */}
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Item Name"
                          optionFilterProp="children"
                          value={state.itemName || "Item Name"}
                          onChange={(e) => {
                            const { itemName } = state.items.find(
                              (el) => el.itemCode === e
                            );
                            setState({
                              ...state,
                              itemCode: e,
                              itemName: itemName,
                            });
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Party Id :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="Party Id"
                          optionFilterProp="children"
                          value={state.partyId || "Party Id "}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyId}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Party Name :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Party Name"
                          optionFilterProp="children"
                          value={state.partyName || "Party Name"}
                          onChange={(e) => {
                            const lCode = state.parties.find(
                              (el) => el.partyId === e
                            );
                            setState({
                              ...state,
                              partyId: e,
                              partyName: lCode.partyName,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.partyName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Closed:
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.closed === "" ? "No" : state.closed}
                          onChange={(value) =>
                            onChangeText({ target: { name: "closed", value } })
                          }
                        >
                          <Option value={0} name="closed">
                            No
                          </Option>
                          <Option value={1} name="closed">
                            Yes
                          </Option>
                        </Select>
                      </div>
                      {type === "EDIT" && (
                        <div className="w-1/2 mb-3">
                          <label className="text-white ml-3" htmlFor="fname">
                            Edit Registration Number :
                          </label>
                          <input
                            type="text"
                            name="regNumber"
                            value={state.regNumber}
                            onChange={onChangeText}
                            className="bg-black text-slate-400 pl-2 ml-3  inpTxt h-8 w-full"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={saveTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded">
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={saveEditTank}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vehical;
